import { render, staticRenderFns } from "./reqs.vue?vue&type=template&id=43153be5&scoped=true&"
import script from "./reqs.vue?vue&type=script&lang=js&"
export * from "./reqs.vue?vue&type=script&lang=js&"
import style0 from "./reqs.vue?vue&type=style&index=0&id=43153be5&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43153be5",
  null
  
)

export default component.exports